
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.252 5.672a6.543 6.543 0 0 1 4.619 4.62m-5.296-2.097a3.926 3.926 0 0 1 2.772 2.772",
  stroke: "#423F45",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M8.464 12.598a7.577 7.577 0 0 0 3.508 3.492.712.712 0 0 0 .704-.053l2.248-1.5a.718.718 0 0 1 .682-.062l4.208 1.803c.293.125.47.428.43.745a4.313 4.313 0 0 1-4.277 3.766C9.22 20.79 3.75 15.32 3.75 8.572a4.313 4.313 0 0 1 3.766-4.278.716.716 0 0 1 .745.431l1.805 4.211a.718.718 0 0 1-.06.677l-1.494 2.284a.712.712 0 0 0-.048.7z",
  stroke: "#423F45",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M14.252 5.672a6.543 6.543 0 0 1 4.619 4.62M13.575 8.195a3.926 3.926 0 0 1 2.772 2.772\" stroke=\"#423F45\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path clip-rule=\"evenodd\" d=\"M8.464 12.598a7.577 7.577 0 0 0 3.508 3.492.712.712 0 0 0 .704-.053l2.248-1.5a.718.718 0 0 1 .682-.062l4.208 1.803c.293.125.47.428.43.745a4.313 4.313 0 0 1-4.277 3.766C9.22 20.79 3.75 15.32 3.75 8.572a4.313 4.313 0 0 1 3.766-4.278.716.716 0 0 1 .745.431l1.805 4.211a.718.718 0 0 1-.06.677l-1.494 2.284a.712.712 0 0 0-.048.7z\" stroke=\"#423F45\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-phone.213838499865ecb86ba4e8306ea7412b.svg"),
        {
          React: SvgIconPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      